import React, {useCallback, useEffect, useState} from 'react';
import styled from 'styled-components';
import {TextField} from '../textField/TextField';
import {SearchIcon} from '../../icons/SearchIcon';
import {AccentColorProps} from 'epic-ue-theme/src/types/colors.types';
import {useLocalization} from '@epic-mw/localization';
import {RemoveIcon} from '../../icons/RemoveIcon';

const Styled = styled.div`
    &.large {
        height: 62px;
        .MuiInputBase-root,
        input {
            height: 62px !important;
            padding: 12px !important;
        }
    }

    .ue-icon-search {
        padding: 2px 0;
        margin-left: 6px;
        margin-right: 4px;
    }

    .ue-icon-remove {
        cursor: pointer;
    }

    input::placeholder {
        opacity: 1;
    }
`;

export interface SearchFieldProps extends AccentColorProps {
    searchLabelText?: string;
    searchKeyword?: string;
    variant?: 'default' | 'large';
    onChange?: (searchText: string) => void;
    onKeyUp?: (e: any, searchText: string) => void;
    clearSearch?: () => void;
}

export const SearchField = ({
    accentColor,
    searchKeyword = '',
    searchLabelText,
    variant = 'default',
    onChange,
    onKeyUp,
    clearSearch
}: SearchFieldProps): JSX.Element => {
    const getMessage = useLocalization();
    const [searchText, setSearchText] = useState(searchKeyword);

    useEffect(() => {
        setSearchText(searchKeyword || '');
    }, [searchKeyword]);

    const textOnChange = useCallback(
        (e) => {
            const value = e.target.value;
            setSearchText(value);
            if (onChange) {
                onChange(value);
            }
        },
        [onChange, setSearchText]
    );

    const clear = useCallback(
        (e) => {
            setSearchText('');
            if (onChange) {
                onChange('');
            }
            if (clearSearch) {
                clearSearch();
            }
        },
        [onChange, setSearchText]
    );

    return (
        <Styled className={`search-field ${variant}`}>
            <TextField
                placeholder={searchLabelText || getMessage('epic.common.search') || 'Search'}
                value={searchText}
                startAdornment={<SearchIcon color={accentColor} />}
                endAdornment={searchText && searchText.length ? <RemoveIcon onClick={clear} /> : ''}
                onChange={textOnChange}
                onKeyUp={(e) => {
                    onKeyUp && onKeyUp(e, searchText);
                }}
            />
        </Styled>
    );
};
